// eslint-disable-next-line require-jsdoc

const getCommonMethod = () => {
  if (window.webkit && window.webkit.messageHandlers) {
    // It will come in iOS
    return window.webkit.messageHandlers.CommunicationWindow;
  }
  if (window.CommunicationWindow) {
    // It will come in Android
    return window.CommunicationWindow;
  }
  return new Error('asdgkjbsdkjgb');
};

export default getCommonMethod;
